export default "__VITE_ASSET__487003af__"